// extracted by mini-css-extract-plugin
export var BlackText = "CardAnchorNavigation-module--BlackText--QP4h8";
export var HiddenLg = "CardAnchorNavigation-module--HiddenLg--NCpzI";
export var HiddenMd = "CardAnchorNavigation-module--HiddenMd--soErM";
export var HiddenXl = "CardAnchorNavigation-module--HiddenXl--Qj0gz";
export var HiddenXs = "CardAnchorNavigation-module--HiddenXs--VXZK2";
export var TextAlignRightXs = "CardAnchorNavigation-module--TextAlignRightXs--mwrmq";
export var WhiteText = "CardAnchorNavigation-module--WhiteText--IzY2f";
export var black = "#181818";
export var blackHSL = "0 0% 9%";
export var card = "CardAnchorNavigation-module--card--3D1LI";
export var cardArrow = "CardAnchorNavigation-module--cardArrow--pKm0F";
export var cardContent = "CardAnchorNavigation-module--cardContent--5jNQH";
export var cardDescription = "CardAnchorNavigation-module--cardDescription--YGZOY";
export var cardLabel = "CardAnchorNavigation-module--cardLabel--xAWJZ";
export var cardLink = "CardAnchorNavigation-module--cardLink--3wkER";
export var cardTitle = "CardAnchorNavigation-module--cardTitle--HVjbr";
export var cardsContainer = "CardAnchorNavigation-module--cardsContainer--WTd3H";
export var desktopWidth = "960px";
export var lgBreakpoint = "60rem";
export var mdBreakpoint = "40rem";
export var srOnly = "CardAnchorNavigation-module--sr-only--LcwN0";
export var visuallyHidden = "CardAnchorNavigation-module--visually-hidden--260rd";
export var white = "#fcfcfc";
export var whiteHSL = "0 0% 99%";
export var wrapper = "CardAnchorNavigation-module--wrapper--KdU4W";